import React from 'react';
import { t } from '@lingui/core/macro';
import Download from 'shared/ui/icons/General/Download';

import IconButton, {IIconButtonProps} from './IconButton';

type IExportButtonProps = Omit<IIconButtonProps, 'icon' | 'title'>;

const ExportButton: React.FC<IExportButtonProps> = (props) => {

    return (
        <IconButton
            icon={<Download />}
            title={t`Экспорт`}
            {...props}
        />
    );
};

export default ExportButton;
